import {
  AUTH_SET_USER_ID,
  AUTH_SET_EMAIL,
  AUTH_SET_ROLES,
  AUTH_SET_PERMISSIONS,
  AUTH_SET_ACCESS_TOKEN,
  AUTH_SET_ACCESS_TOKEN_DATE,
  AUTH_SET_ACCESS_SESSION,
  AUTH_SET_REFRESH_TOKEN,
  AUTH_SET_REFRESHING,
  AUTH_SET_STAFF_ID,
  AUTH_SET_STAFF_NAME,
  AUTH_SET_STATUS,
  AUTH_SET_ERROR,
  AUTH_RESET
} from "@/store/mutation-types";

// let mutation_types = {
//   AUTH_SET_USER_ID,
//   AUTH_SET_EMAIL,
//   AUTH_SET_ROLES,
//   AUTH_SET_PERMISSIONS,
//   AUTH_SET_ACCESS_TOKEN,
//   AUTH_SET_ACCESS_SESSION,
//   AUTH_SET_REFRESH_TOKEN,
//   AUTH_SET_STAFF_ID,
//   AUTH_SET_STAFF_NAME,
//   AUTH_SET_STATUS,
//   AUTH_SET_ERROR,
//   AUTH_RESET
// };

import {
  // AUTH_REGISTER_REQUEST,
  // AUTH_CREATE_GUEST,
  // AUTH_RESEND_CONFIMATION,
  // AUTH_VERIFY,
  AUTH_LOGOUT,
  // AUTH_LOGIN,
  // AUTH_CHECK_LOGIN,
  AUTH_STAFF,
  LAB_CONTEXT_INIT
} from "@/store/action-types";

// let action_types = {
//   AUTH_REGISTER_REQUEST,
//   AUTH_CREATE_GUEST,
//   AUTH_RESEND_CONFIMATION,
//   AUTH_VERIFY,
//   AUTH_LOGOUT,
//   AUTH_LOGIN,
//   AUTH_CHECK_LOGIN,
//   AUTH_STAFF
// };

import AuthRepository from "@/auth/AuthRepository";
import UserModel from "@/models/lab/UserModel";

const getDefaultState = () => {
  return {
    user_id: getCookie("auth__user_id"),
    user_email: getCookie("auth__user_email"),
    user_roles: getCookie("auth__user_roles"),
    user_permissions: getCookie("auth__user_permissions"),
    access_token: getCookie("auth__access_token"),
    access_session: getCookie("auth__access_session"),
    refresh_token: getCookie("auth__refresh_token"),
    staff_id: getCookie("auth__staff_id"),
    staff_name: getCookie("auth__staff_name"),
    status: null,
    error: null
  };
};

const state = getDefaultState();

function getCookie(key) {
  let val = localStorage.getItem(key);
  if (val && val !== "") {
    return val;
  }
  return null;
}

const getters = {
  getAuthUserID: state => state.user_id,
  getAuthEmail: state => state.user_email,
  getAuthRoles: state => state.user_roles,
  getAuthPermissions: state => state.user_permissions,
  getAuthAccessToken: state => state.access_token,
  getAuthAccessTokenDate: state => state.access_token_date,
  getAuthSession: state => state.access_session,
  getAuthRefreshToken: state => state.refresh_token,
  getAuthStaffID: state => state.staff_id,
  getAuthStaffName: state => state.staff_name,
  getAuthenticationStatus: state => state.status,
  getAuthenticationError: state => state.error,
  isAuthenticated: state => !!state.access_token,
  hasError: state => !!state.error
};

function cleanMutationValue(val) {
  if (val && val !== "") {
    return val;
  }
  return null;
}

const mutations = {
  AUTH_SET_USER_ID(state, user_id) {
    state.user_id = cleanMutationValue(user_id);
    localStorage.setItem("auth__user_id", state.user_id);
  },
  AUTH_SET_EMAIL(state, email) {
    state.email = cleanMutationValue(email);
    localStorage.setItem("auth__email", state.email);
  },
  AUTH_SET_ROLES(state, roles) {
    state.user_roles = cleanMutationValue(roles);
    localStorage.setItem("auth__user_roles", state.user_roles);
  },
  AUTH_SET_PERMISSIONS(state, permissions) {
    state.user_permissions = cleanMutationValue(permissions);
    localStorage.setItem("auth__user_permissions", state.user_permissions);
  },
  AUTH_SET_ACCESS_TOKEN(state, access_token) {
    state.access_token = cleanMutationValue(access_token);
    localStorage.setItem("auth__access_token", state.access_token);
  },
  AUTH_SET_ACCESS_TOKEN_DATE(state, date) {
    state.access_token_date = cleanMutationValue(date);
    localStorage.setItem("auth__access_token_date", state.access_token_date);
  },
  AUTH_SET_ACCESS_SESSION(state, access_session) {
    state.access_session = cleanMutationValue(access_session);
    localStorage.setItem("auth__access_session", state.access_session);
  },
  AUTH_SET_REFRESH_TOKEN(state, refresh_token) {
    state.refresh_token = cleanMutationValue(refresh_token);
    localStorage.setItem("auth__refresh_token", state.refresh_token);
  },
  AUTH_SET_REFRESHING(state, refreshing_token) {
    state.refreshing_token = cleanMutationValue(refreshing_token);
    localStorage.setItem("auth__refreshing_token", state.refreshing_token);
  },
  AUTH_SET_STAFF_ID(state, staff_id) {
    state.staff_id = cleanMutationValue(staff_id);
    localStorage.setItem("auth__staff_id", state.staff_id);
  },
  AUTH_SET_STAFF_NAME(state, staff_name) {
    state.staff_name = cleanMutationValue(staff_name);
    localStorage.setItem("auth__staff_name", state.staff_name);
  },
  AUTH_SET_STATUS(state, status) {
    state.status = cleanMutationValue(status);
  },
  AUTH_SET_ERROR(state, error) {
    state.error = cleanMutationValue(error);
  },
  AUTH_RESET(state) {
    localStorage.clear();
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  AUTH_REGISTER_REQUEST: (
    { commit },
    { attributes }
  ) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "register__request");
      if (attributes.phone_number) {
        attributes.phone_number =
          `+${attributes.phone_number.replace(/\D/g, "")}`;
      }
      AuthRepository.signUp()
        .then(data => {
          commit(AUTH_SET_USER_ID, data.id);
          commit(AUTH_SET_EMAIL, data.email);
          if (data.confirmed) {
            commit(AUTH_SET_STATUS, "register__success");
          } else {
            commit(AUTH_SET_STATUS, "register__confirmation");
          }
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "register__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Sign up error");
          reject(err);
        });
    });
  },

  AUTH_CREATE_GUEST: ({ commit }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "create_guest__request");
      AuthRepository.signUpGuest(username, username, password)
        .then(data => {
          commit(AUTH_SET_USER_ID, data.id);
          commit(AUTH_SET_EMAIL, data.email);
          commit(AUTH_SET_STATUS, "create_guest__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "create_guest__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Create guest error");
          reject(err);
        });
    });
  },

  AUTH_RESEND_CONFIMATION: ({ commit }, { username }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "confirmation__resend");
      AuthRepository.resendConfirmation(username)
        .then(data => {
          commit(AUTH_SET_STATUS, "confirmation__resent");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "confirmation__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Re-send error");
          reject(err);
        });
    });
  },

  AUTH_CONFIRMATION: ({ commit }, { username, code }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "confirmation__request");
      AuthRepository.confirmSignUp(username, code)
        .then(data => {
          commit(AUTH_SET_STATUS, "confirmation__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "confirmation__error");
          let msg = parseErrResponse(err);
          if (msg == "User cannot be confirm. Current status is CONFIRMED") {
            commit(AUTH_SET_ERROR, "User is already confirmed.");
          } else {
            commit(AUTH_SET_ERROR, msg !== null ? msg : "Confirmation error");
          }
          reject(err);
        });
    });
  },

  AUTH_LOGOUT: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "sign_out__request");

      // if no token or token is stale, just clear the state
      if (!state.access_token || (parseInt(state.access_token_date) + (10 * 60 * 1000)) < Date.now()) {
        commit(AUTH_RESET);
        commit(AUTH_SET_STATUS, "sign_out__success");
        commit(AUTH_SET_ROLES, null);
        commit(AUTH_SET_PERMISSIONS, null);
        resolve();
      } else {
        AuthRepository.logout()
          .then(data => {
            commit(AUTH_RESET);
            commit(AUTH_SET_STATUS, "sign_out__success");
            commit(AUTH_SET_ROLES, null);
            commit(AUTH_SET_PERMISSIONS, null);
            resolve(data);
          })
          .catch((err) => {
            // If error, log out user by clearing the state
            commit(AUTH_RESET);
            commit(AUTH_SET_STATUS, "sign_out__success");
            commit(AUTH_SET_ROLES, null);
            commit(AUTH_SET_PERMISSIONS, null);
            resolve();
          });
      }
    });
  },

  async AUTH_STAFF({ commit }, { user_id }) {
    return await new Promise((resolve, reject) => {
      const user = new UserModel({ id: user_id });
      user
        .fetch()
        .then(() => {
          const staff = user.getStaff();
          if (staff.id) {
            commit(AUTH_SET_STAFF_ID, staff.id);
            commit(
              AUTH_SET_STAFF_NAME,
              `${staff.first_name} ${staff.last_name}`
            );
          }
          resolve(staff);
        })
        .catch(err => {
          reject(err || null);
        });
    });
  },

  AUTH_LOGIN: ({ commit, dispatch }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "sign_in__request");
      AuthRepository.login(username, password)
        .then(response => {
          const { data } = response.data;
          if (data.state === "challenge") {
            commit(AUTH_SET_STATUS, "sign_in__password_required");
            commit(AUTH_SET_ACCESS_SESSION, data.session);
            resolve();
          } else {

            commit(AUTH_SET_STATUS, "sign_in__success");
            commit(AUTH_SET_USER_ID, data.uuid);
            commit(AUTH_SET_EMAIL, username);
            commit(AUTH_SET_ROLES, data.roles);
            commit(AUTH_SET_PERMISSIONS, data.permissions);
            commit(AUTH_SET_ACCESS_TOKEN, data.token);
            commit(AUTH_SET_ACCESS_TOKEN_DATE, Date.now());
            commit(AUTH_SET_REFRESH_TOKEN, data.refresh);

            dispatch(AUTH_STAFF, { user_id: data.uuid })
              .then(staff => {
                dispatch(LAB_CONTEXT_INIT)
                  .then(() => {
                    resolve(staff);
                  })
                  .catch(err => {
                    err = err || "No labs found";
                    dispatch(AUTH_LOGOUT);
                    commit(AUTH_SET_STATUS, "sign_in__error");
                    commit(AUTH_SET_ERROR, err);
                    reject(err);
                  });
              })
              .catch(err => {
                err = err || "No customer contact found";
                dispatch(AUTH_LOGOUT);
                commit(AUTH_SET_STATUS, "sign_in__error");
                commit(AUTH_SET_ERROR, err);
                reject(err);
              });
          }
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "sign_in__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Sign in error");
          reject(err);
        });
    });
  },

  async AUTH_CHECK_LOGIN({ state, commit, dispatch }) {
    console.log('AUTH_SET_REFRESHING: ' + state.refreshing_token);

    // check if the access token is less than ten minutes old
    if (state.access_token && (parseInt(state.access_token_date) + (10 * 60 * 1000)) >= Date.now()) {
      // token still fresh -- do nothing
      console.log('token still fresh -- do nothing');
      return;
    } else if (state.refreshing_token && state.refresh_token && (parseInt(state.refreshing_token) + (1.5 * 60 * 1000)) >= Date.now()) {
      // refresh already pending
      console.log('token already being refreshed -- do nothing');
      return;
    } else {
      try {
        // token stale - needs to be refreshed
        console.log('token stale -- refresh');

        commit(AUTH_SET_REFRESHING, Date.now());
        commit(AUTH_SET_STATUS, "refresh__request");
  
        if (!state.access_token || !state.refresh_token) {
          console.log('token stale -- in reject???');
          throw new Error('Access token or refresh token is missing');
        }
  
        const response = await AuthRepository.refresh(state.refresh_token, state.access_token);
        const { data } = response.data;
  
        commit(AUTH_SET_STATUS, "refresh__success");
        commit(AUTH_SET_ACCESS_TOKEN, data.token);
        commit(AUTH_SET_ACCESS_TOKEN_DATE, Date.now());
        commit(AUTH_SET_REFRESH_TOKEN, data.refresh);
        commit(AUTH_SET_ROLES, data.roles);
        commit(AUTH_SET_PERMISSIONS, data.permissions);
        
        // set 'refreshing' state null (done)  
        commit(AUTH_SET_REFRESHING, null);
  
        if (!state.staff_id) {
          dispatch(AUTH_STAFF, { user_id: state.user_id });
        }
  
        return data.id;
      } catch (error) {
        // set 'refreshing' state null (done)
        commit(AUTH_SET_REFRESHING, null);
        console.log('ERROR - AUTH_SET_REFRESHING: ' + state.refreshing_token);
        dispatch(AUTH_LOGOUT);
        throw error;
      }
    }
  },

  async AUTH_INVITE({ commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "invite__request");
      AuthRepository.invite(email, email, password)
        .then(data => {
          commit(AUTH_SET_USER_ID, data.id);
          commit(AUTH_SET_EMAIL, email);
          commit(AUTH_SET_STATUS, "invite__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "invite__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Invite error");
          reject(err);
        });
    });
  },

  async AUTH_SET_NEW_PASSWORD({ commit, state }, { username, password }) {
    return new Promise((resolve, reject) => {
      let session = state.access_session;
      commit(AUTH_SET_STATUS, "change__request");
      AuthRepository.change(username, password, session)
        .then(data => {
          commit(AUTH_SET_STATUS, "change__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "change__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Password change error");
          reject(err);
        });
    });
  },
  async AUTH_PASSWORD_RESET_REQUEST({ commit }, { username }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "password_reset_request__request");
      AuthRepository.passwordReset(username)
        .then(data => {
          commit(AUTH_SET_EMAIL, username);
          commit(AUTH_SET_STATUS, "password_reset_request__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "password_reset_request__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Password reset request error");
          reject(err);
        });
    });
  },
  async AUTH_PASSWORD_RESET_COMPLETE({ commit }, { username, code, password }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "password_reset_confirm__request");
      AuthRepository.passwordResetConfirm(username, code, password)
        .then(data => {
          commit(AUTH_SET_EMAIL, username);
          commit(AUTH_SET_STATUS, "password_reset_confirm__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "password_reset_confirm__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Password reset confirm error");
          reject(err);
        });
    });
  },
};

function parseErrResponse(err) {
  if (typeof err === "string") {
    return err;
  } else if (typeof err === "object" && err.response) {
    if (err.response.data && err.response.data.data && err.response.data.data.message) {
      return err.response.data.data.message;
    } else if (err.response.data && err.response.data.message) {
      return err.response.data.message;
    } else {
      return err.message;
    }
  } else if (typeof err === "object" && err.message) {
    return err.message;
  }
  return null;
}

export default {
  getters,
  mutations,
  actions,
  state
};
